<template>
  <el-container>
    <!-- 主体内容 -->
    <el-header
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>编辑负面舆情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button
          type="info"
          icon="el-icon-eleme"
          @click.native="formSubmit(false)"
          :disabled="data.node.isSucces == true"
          >保存</el-button
        >
        <!-- ||
            uploadList == null ||
            uploadList.length == 0 -->
        <el-button
          :disabled="
            data.node.isSucces == true 
          "
          type="info"
          icon="el-icon-eleme"
          @click.native="formSubmit(true)"
          >工单提交</el-button
        >

        <el-button type="info" icon="el-icon-back" @click.native="formReturn()"
          >返 回</el-button
        ></el-button-group
      >
    </el-header>
    <el-main>
      <el-tabs type="card" :tab-position="tabPosition">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-date"></i> 工单信息 </span>
          <el-form
            :model="data.pst"
            status-icon
            label-width="100px"
            ref="refForm"
            :rules="rules"
          >
            <el-form-item label="工单类型" prop="pstType">
              <el-select v-model="data.pst.pstType" placeholder="请选择">
                <el-option
                  v-for="pstType in pstApi.pstTypes.filter((item) =>
                    data.user.hasRoles.isAdmin || data.user.hasRoles.isSuper
                      ? item.value >= 0
                      : item.value == 1
                  )"
                  :key="pstType.value"
                  :label="pstType.title"
                  :value="pstType.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发贴标题" prop="title">
              <el-input
                v-model="data.pst.title"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="发贴地址" prop="pstUrl">
              <el-input
                v-model="data.pst.pstUrl"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="发贴人" prop="name">
              <el-input
                v-model="data.pst.name"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="发贴时间" prop="postingTime">
              <el-input
                v-model="data.pst.postingTime"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="来源" prop="pstSource">
              <el-input
                v-model="data.pst.pstSource"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="贴子内容" prop="pstContent">
              <el-input
                type="textarea"
                :rows="8"
                v-model="data.pst.pstContent"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="上传佐证" prop="pstContent">
              <el-card class="box-card">
                <!-- 文件上传组件 -->
                <upload
                  :nodeId="data.node.id"
                  :uploadTypes="uploadTypes"
                  @uploadchange="uploadchange"
                  :disabled="data.node.isSucces"
                />
              </el-card>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"
            ><i :class="pstApi.getStatusIcon(data.node.status)"></i>
            {{ pstApi.getNodeTitle(data.node.status) }}
          </span>
          <el-form :model="data.node" status-icon label-width="100px">
            <el-form-item label="办理单位">
              <el-input v-model="data.node.unitName" disabled />
            </el-form-item>
            <el-form-item label="办理人">
              <el-input v-model="data.node.userName" disabled />
            </el-form-item>
            <el-form-item
              v-if="data.node.nodeContent.length > 0"
              label="答复留言"
            >
              <el-input
                type="textarea"
                :rows="3"
                v-model="data.node.nodeContent"
                disabled
              />
            </el-form-item>
            <el-form-item label="提交说明">
              <el-input
                type="textarea"
                :rows="3"
                v-model="data.node.nodeMessage"
                :disabled="data.node.isSucces"
              />
            </el-form-item>
            <el-form-item label="状态">
              <el-input
                :value="data.node.isSucces ? '已提交' : '未提交'"
                disabled
              />
            </el-form-item>
            <el-form-item label="最后修改时间" v-if="data.node.id">
              <el-input
                :value="
                  data.node.lastTime
                    ? Common.dateFormatter(
                        data.node.lastTime,
                        'yyyy-MM-dd hh:mm'
                      )
                    : ''
                "
                disabled
              />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>
  
<script>
// 导入组件
import upload from "../../../components/Contents.vue";
export default {
  components: {
    upload,
  },
  created() {
    this.pstApi.setWindowTitle("编辑工单信息");
    this.data.pst.id = this.$route.params.id;
    this.data.user = this.pstApi.getUserData();
    this.getPst(); //读取舆情信息
  },
  data() {
    var checkPstType = (rules, value, callback) => {
      if (value != 0 && value != 1) {
        callback(new Error("类型错误!"));
      } else if (
        value == 0 &&
        this.data.user.isAdmin == false &&
        data.user.isSuper == false
      ) {
        callback(new Error("类型权限不足!"));
      } else {
        callback();
      }
    };
    var checkUrl = (rules, value, callback) => {
      if (!this.Common.isURL(value)) {
        callback(new Error("网址格式错误!"));
      } else {
        callback();
      }
    };
    var checkPostTime = (rules, value, callback) => {
      if (!this.Common.isDate(value)) {
        callback(new Error("日期格式错误!"));
      } else if (new Date(value) < new Date("2024-1-1")) {
        callback(new Error("日期不能小于（2024-1-1）"));
      } else {
        callback();
      }
    };
    return {
      tabPosition: "right",
      uploadTypes: [
        { title: "图片", value: "0" },
        { title: "视频", value: "1" },
      ],
      uploadList: [],
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
          pstType:'',
          title: "",
          pstUrl: "",
          name: "",
          postingTime: "",
          pstSource: "",
          pstContent: "",
        },
        user:'',
        nodes: [],
        node: {
          id: "",
          pstId: "5",
          status: -2,
          pstType: 1,
          transferUnitId: "",
          transferUnitName: "",
          isSucces: false,
          unitId: "",
          unitName: "",
          userId: "",
          userName: "",
          nodeMessage: "",
          nodeContent: "",
          lastTime: "2023-12-17 06:12:59",
        },
      },
      rules: {
        pstType: [{ required: true, trigger: "blur", validator: checkPstType }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        pstUrl: [{ required: true, trigger: "blur", validator: checkUrl }],
        postingTime: [
          { required: true, trigger: "blur", validator: checkPostTime },
        ],
        name: [{ required: true, message: "请输入发贴人", trigger: "blur" }],
        pstSource: [{ required: true, message: "请输入来源", trigger: "blur" }],
        pstContent: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //读取舆情信息
    getPst() {
      this.pstApi
        .getHandlePstInfo(this.data.pst.id)
        .then((res) => {
          var data = res.data;
          this.data.pst = data;
          this.data.nodes = data.nodeInfos;
          this.data.statusName = data.isSucces == false ? "已保存" : "已提交";
          //this.pstApi.getStatusTitle(data.status);
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
          var len = data.nodeInfos.length;
          if (len != 1) {
            this.$toast("节点数不正确");
            return;
          }
          this.data.node = data.nodeInfos[0];
          //console.log(this.data.node);
        })
        .catch((err) => {
          this.$toast("读取失败");
        });
    },
    formReturn() {
      // this.$router.back();
      this.$router.push({ name: "Negatives" });
    },
    uploadchange(uploadList) {
      //console.log("uploadList:",uploadList)
      this.uploadList = uploadList;
    },
    formSubmit(isSucces) {
      this.$refs["refForm"].validate(async (valid) => {
        if (!valid) {
          console.log("error submit!!");
          this.$toast("数据校验错误");
          return false;
        } else {
          //return false;
          let pst = this.data.pst;
          let message = this.data.node.nodeMessage;
          if (this.data.node.isSucces) {
            this.$toast("节点已提交，禁止修改");
            return;
          }
          if (isSucces && message == "") {
            message = "请上级部门审查";
            //this.$toast("提交说明不可为空");
            //return;
          }

          //保存舆情信息
          var res = await this.pstApi.updateNegative(
            pst.id,
            pst.title,
            pst.pstUrl,
            pst.name,
            pst.postingTime,
            pst.pstSource,
            pst.pstContent,
            //category
            pst.pstType,
          );
          //保存节点信息
          if (res && res.status == 200) {
            this.$toast("保存成功");
            // if (isSucces == false && message == "") {
            //   return;
            // }
            var ret = await this.pstApi.updateManagerNodeMessage(
              pst.id,
              message,
              isSucces
            );
            if (ret && ret.status == 200) {
              this.$toast(ret.data.message);
              if (isSucces) {
                this.$toast("节点保存成功");
                this.formReturn();
                return;
              }
              this.getPst();
            } else {
              this.$toast("节点保存失败");
            }
          } else {
            this.$toast("保存失败");
          }
        }
      });
    },
    docViewClose() {
      this.data.docViews.docurls = [];
      this.data.docViews.fileExt = "";
    },
  },
};
</script>
  
<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}
//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;
  .btnLeft {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }
  .btnTitle {
    flex: 2;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
  .btnStatus {
    flex: 1;
    margin: 0;
    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  .el-button-group > .el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.el-select {
  float: left;
}
.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}
/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}
/deep/.el-input.is- .el-input__inner {
  color: #031944;
}
/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
//
.img-list {
  overflow: hidden;
  width: 100%;
  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }
    // 底部
    .img-li-b--bottom {
      margin-top: 10px;
      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }
    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }
    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);
      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }
    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }
    // 悬浮可见删除 or 放大按钮
    &:hover {
      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }
    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;
    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}
.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;
  .el-button {
    flex: 1;
  }
}
</style>